import { render, staticRenderFns } from "./offline_purchase_edit.vue?vue&type=template&id=135dd91c&scoped=true"
import script from "./offline_purchase_edit.vue?vue&type=script&lang=js"
export * from "./offline_purchase_edit.vue?vue&type=script&lang=js"
import style0 from "./offline_purchase_edit.vue?vue&type=style&index=0&id=135dd91c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135dd91c",
  null
  
)

export default component.exports